import { FunctionComponent, h } from 'preact';

interface IMarkdownProps {
    content: string;
    element?: 'div' | 'span';
    [key: string]: any;
}

export const Markdown: FunctionComponent<IMarkdownProps> = ({
    content,
    element: Element = 'div',
    ...props
}) => <Element dangerouslySetInnerHTML={{ __html: content }} {...props} />;
